module.exports = __webpack_public_path__ + "img/bed-icon.bf8a33d9.svg";